export default {"src":"https://images-cdn.curipod.com/d-44cd0990/_next/static/media/loaderstars.62e39e18.svg","height":669,"width":679};